import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';

import css from './MainPanelHeader.module.css';
import verified from "./images/verified.svg";
import insured from "./images/insured.svg";
import clearpricing from "./images/clearpricing.svg";
import count1 from "./images/count-1.svg";
import count2 from "./images/count-2.svg";
import count3 from "./images/count-3.svg";
/**
 * MainPanelHeader component
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {React.Node} props.children - The children
 * @param {React.Node} props.sortByComponent - The sort by component
 * @param {boolean} props.isSortByActive - Whether the sort by is active
 * @param {boolean} props.listingsAreLoaded - Whether the listings are loaded
 * @param {number} props.resultsCount - The results count
 * @param {boolean} props.searchInProgress - Whether the search is in progress
 * @param {React.Node} props.noResultsInfo - The no results info
 * @returns {JSX.Element}
 */
const MainPanelHeader = props => {
  const {
    rootClassName,
    className,
    children,
    sortByComponent,
    isSortByActive,
    listingsAreLoaded,
    resultsCount,
    searchInProgress = false,
    noResultsInfo,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <span className={css.cardtag}>Search | Compare | Save</span>
      <span className={css.cardTitle}>Book with confidence in 3 simple steps</span>
      <div className={css.stepsRow} style={{display:'flex',gap:'25px',padding:'0 0 20px 0'}}>
        <div data-tooltip="Every owner is verified before listing, including identity checks, bank account validation, MOT checks, and insurance verification where applicable.">
          <div className={css.infoCard}>
            <div className={css.left}>
              <img src={count1} />
            </div>

            <div className={css.content}>
              <div className={css.infoTitle}>Verified Owners</div>
              <div className={css.subtitle}>Real renter reviews you can trust</div>
            </div>

            <div className={css.right}>
              <img src={verified} className={css.icon} />
            </div>
          </div>
        </div>

        <div data-tooltip="Every booking includes either verified owner self-drive hire insurance or daily GoGallivanting insurance cover during the rental period.">
          <div className={css.infoCard}>
            <div className={css.left}>
              <img src={count2} />
            </div>

            <div className={css.content}>
              <div className={css.infoTitle}>Insurance Included</div>
              <div className={css.subtitle}>Cover included in every booking</div>
            </div>

            <div className={css.right}>
              <img src={insured} className={css.icon} />
            </div>
          </div>
        </div>

        <div data-tooltip="Unlike some platforms, we don’t add booking or platform fees at checkout. The nightly rate you see is the price you pay — fairer for renters, better for owners.">
          <div className={css.infoCard}>
            <div className={css.left}>
              <img src={count3} />
            </div>

            <div className={css.content}>
              <div className={css.infoTitle}>No Hidden Fees</div>
              <div className={css.subtitle}>What you see is what you pay</div>
            </div>

            <div className={css.right}>
              <img src={clearpricing} className={css.icon} />
            </div>
          </div>
        </div>
      </div>
      <div className={css.searchOptions}>
        {/* <div className={css.searchResultSummary}>
          <span className={css.resultsFound}>
            {searchInProgress ? (
              <FormattedMessage id="MainPanelHeader.loadingResults" />
            ) : (
              <FormattedMessage
                id="MainPanelHeader.foundResults"
                values={{ count: resultsCount }}
              />
            )}
          </span>
        </div> */}
        {isSortByActive && sortByComponent ? (
          <div className={css.sortyByWrapper}>
            <span className={css.sortyBy}>
              <FormattedMessage id="MainPanelHeader.sortBy" />
            </span>
            {sortByComponent}
          </div>
        ) : null}
      </div>

      {children}

      {noResultsInfo ? noResultsInfo : null}
    </div>
  );
};

export default MainPanelHeader;
